import React from 'react'
import { amphtml } from '../../../google-amp/react_amp'

interface InnerProps {
    width: number
    height: number
    layout: 'responsive'
    'data-href': string
}
const AmpFacebookElement = amphtml<InnerProps>('facebook')

export interface AmpFacebookProps {
    url: string
    width: number
    height: number
}

export const AmpFacebook: React.FC<AmpFacebookProps> = (props) => (
    <AmpFacebookElement
        width={props.width}
        height={props.height}
        layout="responsive"
        data-href={props.url}
    />
)
